import React from 'react';
import { Plus, Minus } from 'lucide-react';

const ZoomControls = ({
  canvasZoom,
  setCanvasZoom,
  showVersionsDropdown,
  sidebarPosition,
  sidebarCollapsed,
  sidebarWidth,
}) => {
  return (
    <div 
      className="absolute z-20 hidden md:block"
      style={{
        top: '50%',
        transform: 'translateY(-50%)',
        right: showVersionsDropdown 
          ? '400px'
          : sidebarPosition === 'right' && !sidebarCollapsed 
            ? `${sidebarWidth + 16}px` 
            : '16px'
      }}
    >
      <div className="flex flex-col items-center gap-1.5 rounded-xl border border-gray-200/80 bg-white p-1.5 shadow-float dark:border-white/10 dark:bg-gray-800">
        <button
          onClick={() => setCanvasZoom(Math.min(2, canvasZoom + 0.1))}
          className="btn btn-ghost btn-sm btn-icon"
          title="Zoom In"
        >
          <Plus className="w-4 h-4" />
        </button>
        
        <div className="relative h-32 flex items-center justify-center">
          <input
            type="range"
            min="10"
            max="200"
            step="5"
            value={canvasZoom * 100}
            onChange={(e) => setCanvasZoom(parseInt(e.target.value) / 100)}
            className="absolute w-32 h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
            style={{
              transform: 'rotate(-90deg)',
              transformOrigin: 'center'
            }}
          />
        </div>
        
        <button
          onClick={() => setCanvasZoom(Math.max(0.1, canvasZoom - 0.1))}
          className="btn btn-ghost btn-sm btn-icon"
          title="Zoom Out"
        >
          <Minus className="w-4 h-4" />
        </button>
        
        <div className="w-full border-t border-gray-100 pt-1.5 pb-0.5 text-center font-mono text-[11px] font-medium tabular-nums text-gray-500 dark:border-white/[0.06] dark:text-gray-400">
          {Math.round(canvasZoom * 100)}%
        </div>
      </div>
    </div>
  );
};

export default ZoomControls;
